/**
 *
 * MainModeFavorite
 *
 */

import { mapState, mapGetters, mapActions } from 'vuex';
//import _ from 'lodash';

import Spinner from '@/components/Spinner.vue';
import Player from '@/components/Player.vue';
import SelectBookMenu from '@/views/Bookmark/components/SelectBookMenu.vue';
import SelectBookScrollMenu from '@/views/MainMode/MainModeCourse/MainModeFavorite/components/SelectBookScrollMenu.vue';
import EmptyVideoList from '@/views/Bookmark/components/VideoList/EmptyVideoList.vue';
import VideoList from '@/views/Bookmark/components/VideoList/VideoList.vue';

import { ClassRestrictionMixin } from '@/mixins/ClassRestriction';
import { AddToFavoriteListMixin } from '@/mixins/Bookmark/AddToFavoriteList';
import { BookmarkMixin } from '@/mixins/Bookmark';
import { FavoriteSelectBookMixin } from '@/mixins/Bookmark/FavoriteSelectBook';
import { FavoriteSelectCourseMixin } from '@/mixins/Bookmark/FavoriteSelectCourse';

import { LOADING_MESSAGE } from './MainModeFavorite.constants';

export default {
  name: 'MainModeFavorite',

  components: {
    Spinner,
    Player,
    SelectBookMenu,
    SelectBookScrollMenu,
    EmptyVideoList,
    VideoList,
  },

  mixins: [
    ClassRestrictionMixin,
    AddToFavoriteListMixin,
    BookmarkMixin,
    FavoriteSelectBookMixin,
    FavoriteSelectCourseMixin,
  ],

  data() {
    return {
      loadingMessage: LOADING_MESSAGE,

      promiseGetFavoriteList: null,
    };
  },

  computed: {
    ...mapState('MainModeCourse', {
      ms_MainModeCourse_isRequest: 'isRequest',
    }),

    ...mapState('MainModeCourse/MainModeFavorite', {
      ms_isRequest: 'isRequest',
    }),

    ...mapGetters('MainModeCourse', {
      Course: 'Course',
    }),

    ///
    c_courseId() {
      return Number(this.$route.params.courseId);
    },

    c_isRequest() {
      return !this.ms_MainModeCourse_isRequest && this.ms_isRequest;
    },

    ///
    c_restrictStudent() {
      return this.Course.restrictStudent;
    },
  },

  methods: {
    ...mapActions('MainModeCourse/MainModeFavorite', {
      ma_getFavorite: 'getFavorite',
    }),

    ///
    setPromiseGetClassRestriction() {
      this.promiseClassRestrictionCoursePageInfo = this.promiseGetFavoriteList;
    },

    ///
    async doGetFavoriteList() {
      this.promiseGetFavoriteList = this.ma_getFavorite({
        courseId: this.c_courseId,
      });
      await this.promiseGetFavoriteList;
    },
  },

  created() {
    this.selectCourse(this.c_courseId);
    this.getFavoriteList();
  },
};
